<h2>Du har ett obligatoriskt dokument att ta del av</h2>

<div *ngIf="selectedFileUrl$ | async as url" class="iframe-wrapper">
  <iframe class="margin-top lg a4-ratio" [src]="url | safe"></iframe>
</div>

<div class="margin-top lg">
  <p>Genom att stänga så bekräftar du att du har tagit del av dokumentet.</p>
  <div class="flex space-x-4">
    <button class="bee-button" (click)="closeDialog()">Stäng</button>
    <button class="bee-button secondary" (click)="logout()">Logga ut</button>
  </div>
</div>